import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const LocalFilterSectionStyled = styled.div`
  margin-top: 20px;
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const LimitMessage = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  color: ${(props) => props.theme.atlas.semantic.color.action.primary.hover};
  margin: 0;
`;

export const LimitMessageContainer = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
`;
export const SectionHeaderTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
`;

export const ButtonsDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
`;
